import React from 'react';
import PropTypes from 'prop-types';

import Select from 'components/Select';

class CategoriesDropdown extends React.PureComponent {
  render() {
    const { items } = this.props.initialData;
    const { value, defaultCategory, onChange } = this.props;
    const selectItems = [
      defaultCategory,
      ...items.map((item) => ({
        label: item.name,
        value: item.id,
      })),
    ];
    return (
      <Select
        options={selectItems}
        value={selectItems.find((i) => i.value === value)}
        onChange={onChange}
        placeholder={defaultCategory.label}
        label="Category"
      />
    );
  }
}

CategoriesDropdown.propTypes = {
  initialData: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func,
  defaultCategory: PropTypes.object.isRequired,
};

export default CategoriesDropdown;
